import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "index",
  style: {
    "min-width": "1560px"
  }
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "user_tab"
};
const _hoisted_4 = {
  style: {
    "margin-right": "30px"
  }
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  class: "header-img"
};
const _hoisted_7 = {
  class: "header-input"
};
const _hoisted_8 = {
  class: "search-box"
};
const _hoisted_9 = {
  class: "header-input-search"
};
const _hoisted_10 = {
  class: "header-input-history"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($setup.user_info.phone), 1), _createElementVNode("div", {
    style: {
      "padding": "0 20px"
    },
    onClick: _cache[0] || (_cache[0] = $event => $setup.go('member_index'))
  }, "米檬会员服务首页"), _createElementVNode("div", {
    style: {
      "border-left": "1px solid #95BAC1",
      "padding": "0 20px"
    },
    onClick: _cache[1] || (_cache[1] = $event => $setup.go('home'))
  }, "返回官网"), _createElementVNode("div", {
    style: {
      "border-left": "1px solid #95BAC1",
      "padding": "0 20px"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.call && $setup.call(...args))
  }, "联系客服")])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    onClick: _cache[3] || (_cache[3] = $event => $setup.go('member_index')),
    src: "https://www.mimodental.com/assets/imgData/img/header/logo.png   ",
    alt: ""
  })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("img", {
    class: "search-icon",
    src: "https://www.mimodental.com/assets/imgData/img/header/search.png"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "搜索科普/公益...",
    onKeyup: _cache[4] || (_cache[4] = _withKeys((...args) => $setup.shou && $setup.shou(...args), ["enter", "native"])),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.text = $event)
  }, null, 544), [[_vModelText, $setup.text]])]), _createElementVNode("div", {
    class: "header-input-btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.shou && $setup.shou(...args))
  }, " 搜索 ")]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "header-input-history-item",
    onClick: _cache[7] || (_cache[7] = $event => $setup.go_details_brief('member_details_brief', 4))
  }, " 口腔护理保健 "), _createElementVNode("div", {
    class: "header-input-history-item",
    onClick: _cache[8] || (_cache[8] = $event => $setup.go_details_brief('member_details', 2))
  }, " 牙齿矫正会很痛吗 "), _createElementVNode("div", {
    class: "header-input-history-item",
    onClick: _cache[9] || (_cache[9] = $event => $setup.go('member_welfare'))
  }, " 唇肌功能训练营 ")])]), $setup.fh_btn != 'member_index' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "fh",
    onClick: _cache[10] || (_cache[10] = $event => $setup.go('member_index'))
  }, _cache[12] || (_cache[12] = [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/index_fh.png",
    alt: ""
  }, null, -1), _createElementVNode("span", null, "返回会员服务首页", -1)]))) : _createCommentVNode("", true)])]);
}